var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArrowsInSimple = function SvgIconArrowsInSimple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.207 3.793a1 1 0 0 1 0 1.414L16.664 8.75h2.086a1 1 0 1 1 0 2h-4.5a1 1 0 0 1-1-1v-4.5a1 1 0 1 1 2 0v2.086l3.543-3.543a1 1 0 0 1 1.414 0M4.25 14.25a1 1 0 0 1 1-1h4.5a1 1 0 0 1 1 1v4.5a1 1 0 1 1-2 0v-2.086l-3.543 3.543a1 1 0 0 1-1.414-1.414l3.543-3.543H5.25a1 1 0 0 1-1-1"
  }))));
};
export default SvgIconArrowsInSimple;